module.exports = __webpack_public_path__ + "static/media/1_en.b5bfd1d0.png";